// Шрифты — те же, что во всех продуктах Давида (дизайн-система flow-do):
// Inter — интерфейс, JetBrains Mono — ключи, код и даты, Unbounded — только
// крупные заголовки. Отдаются с нашего же домена, а не с Google Fonts: у
// админки не должно быть внешней зависимости в критическом пути отрисовки.
// Браузер скачает только нужные начертания — кириллица и латиница разделены
// unicode-range.
import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import '@fontsource-variable/unbounded';

import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { ErrorBoundary } from '@/app/ErrorBoundary';
import { AppProviders } from '@/app/providers/AppProviders';
import { router } from '@/app/router';
import { language } from '@/shared/i18n';
import { installActivationOriginTracker } from '@/shared/lib/activationOrigin';
import { realtime } from '@/shared/realtime';
import '@/shared/styles/global.scss';

// Запоминаем, что человек трогал последним, чтобы окна вырастали из
// кнопки, которая их открыла. Слушатели ставятся один раз на документ.
installActivationOriginTracker();

// В index.html стоит lang="ru" — язык по умолчанию. Выбранный язык ставится
// до первой отрисовки: от него зависят переносы, озвучка экранного диктора и
// подбор начертаний шрифта.
document.documentElement.lang = language;

// Живое соединение следит за сеансом само: вошёл — подключается, вышел —
// закрывается. Одно на вкладку.
realtime.start();

const container = document.getElementById('root');

if (!container) {
  throw new Error('В index.html нет элемента #root — монтировать приложение некуда');
}

createRoot(container).render(
  <StrictMode>
    {/* Граница ошибок снаружи провайдеров: иначе падение при создании клиента
        запросов осталось бы неперехваченным и дало бы пустой экран. */}
    <ErrorBoundary>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </ErrorBoundary>
  </StrictMode>,
);
